import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { makeRequest } from "../core/services/v1/request";
import Config from "../core/config";
import NavbarOne from "./separate/NavbarOne";
import Footer from "./separate/Footer";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Pagination } from "@mui/material";
import PageTitleDes from "../core/support/PageTitleDes";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LoaderSkeleton from "../Component/Loader/LoaderSkeleton";

const Blogs = (props) => {
    const navigate = useNavigate();

    const [categories, setCategories] = useState([]);
    const [categoryId, setCategoryId] = useState("all");

    const [blogs, setBlogs] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);
    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
        },
    });
    const fetchCategories = async () => {
        try {
            const res = await makeRequest({
                url: `${Config.V2_API_URL}cms/blog-categories`,
                method: "GET",
            });

            if (res.status) {
                setCategories([{ _id: "all", name: "All" }, ...res.categories]);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const fetchBlogs = async () => {
        try {
            setLoading(true);
            setBlogs([]);

            const res = await makeRequest({
                url: `${Config.V2_API_URL}cms/getBlogs?page=${page}&limit=9&categoryId=${categoryId}`,
                method: "GET",
            });

            if (res.status) {
                setBlogs(res?.getBlogsDetails);
                setTotalPages(res?.totalPages);
            }

            setLoading(false);
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        } catch (err) {
            console.log(err);
            setLoading(false);
            setBlogs([]);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    useEffect(() => {
        fetchBlogs();
    }, [categoryId, page]);

    return (
        <div>
            <div className="min-vh-100 bg-default text-white ">
                <PageTitleDes title={`Crypto Blog | Latest News, Insights & Market Trends`} description={`Stay updated with the latest cryptocurrency news, trading insights, and market trends from Unitic Exchange experts.`} />
                {/* <Helmet>
                    <link rel="canonical" href="https://uniticexchange.com/blogs" />
                    <link rel="canonical" href="https://www.uniticexchange.com/blogs" />
                    <meta name="description" content='btc price' />
                    <meta name="keywords" content="Best crypto exchange for beginners India, crypto exchange India, buy sell crypto coin, crypto trading exchange, trading India, crypto news today,coin market,where buy crypto exchange,best app to buy crypto exchange,Bitcoin trading tips strategies, How to make money trading crypto,Bitcoin signals,Free signals for crypto,How to trade bitcoin,How to trade crypto,Crypto signals experts,Free signals for bitcoin, Free signals for ETH,Free crypto signal provider,Free signal for crypto spot,100% Accuracy signalsIndian crypto exchange, Best crypto exchange in India, How to buy cryptocurrency in India, How to trade crypto futures in India, What are crypto signals?, Are crypto signals profitable?, Taxes on cryptocurrency in India. Lowest fees crypto exchange India, Mobile app for crypto trading India,Secure crypto exchange India, Crypto exchange with high liquidity India, Free crypto signals India, Bitcoin Trading Tips & Strategies, Bitcoin Trading Strategy Guide, How to make money trading crypto, Bitcoin Signals 99% success, Bitcoin Signals High Win Rate, Free Signals for crypto, Bitcoin Trading Free Signals, Bitcoin Trading For Beginning, How to trade bitcoin, How to trade crypto, Crypto Signals Experts, Crypto Trading Tips Free, Free signal for ETH, Free Crypto Signals provide, Free signals for crypto Feature, Free Signals for crypto spot,100% Accuracy signal for crypto, crypto exchange India, buy sell crypto coin, best cryptocurrency exchange, crypto trading platform, digital currency exchange, bitcoin exchange India, Ethereum Ethereum exchange, Litecoin Litecoin exchange, ripple, ripple exchange, cryptocurrency market, crypto wallet, crypto trading India, crypto investment platform, crypto exchange platform, crypto to Encrypt trading AppSource crypto exchange, top cryptocurrency exchange, crypto exchange rates, crypto exchange website, crypto exchange services, crypto exchange platform India,crypto exchange market, crypto exchange fees, crypto exchange comparison, crypto exchange reviews, crypto exchange news, Sell Bitcoin India, Crypto spot trading India, Crypto futures trading India, Buy Crypto In India, Cryptocurrency exchange india, Best Apps for Cryptocurrency in India, Top Cryptocurrency Consultants in Chennai, Best Crypto Currency Exchange in India, Crypto Exchange & Tron Exchange from Chennai, Crypto exchange in chennai india app, Crypto exchange in chennai india price, Free crypto exchange in chennai india, Online crypto exchange in chennai india, Buy Bitcoin & Cryptocurrency in India, Best Crypto Exchanges & Apps in India for 2024, Cryptocurrency Exchange Development Company In India, How to buy Bitcoins in Chennai, Bitcoin and cryptocurrency exchange & trading platform, Buy, Sell & Trade BTC, XRP, ETH, TRX, Sign up for crypto exchange India, Crypto exchange with expert signals India. Crypto exchange regulations, crypto exchange security, crypto exchange API, Unitic, Crypto, Trade, Sell, Crypto Trading, Trading Fees, Exchange, bitcoin, crypto currency, coin, coin dcx, crypto trading,cryptocurrency trading, crypto, crypto news, crypto news today, today crypto news, cap market, cryptocurrency price, crypto prices, crypt market, cryptocurrency news, crypto trading for beginners, trading crypto for beginners, coin market, crypto meaning." />
                    <meta name="description" content='ethereum price' />
                    <meta name="description" content='market capitalization in cryptocurrency' />
                    <meta name="description" content='dogecoin price' />
                    <meta name="description" content='btc price prediction' />
                    <meta name="description" content='FIU Registered Crypto Exchange' />
                    <meta name="description" content='Indian best crypto exchange' />
                    <meta name="description" content='Indian crypto exchange' />
                    <meta name="description" content='Best crypto exchange in India for beginners' />
                    <meta name="description" content='Top Indian cryptocurrency exchanges' />
                </Helmet> */}
                <NavbarOne
                    setTheme={props.setTheme}
                    theme={props.theme}
                />
                <div className="bg-default text-white " style={{ minHeight: "93vh" }}>
                    <ThemeProvider theme={darkTheme}>
                        <div className="container pt-5 pb-3">
                            <div className='mb-' style={{ paddingBottom: '12px' }}>
                                <h1 style={{ fontSize: '1.5rem' }}><strong><ArrowBackIcon onClick={() => navigate(-1)} style={{ cursor: "pointer" }} /> Blog</strong></h1>
                                {/* <p className='pt-2' style={{ color: '#C8C8C8' }}>Refer your Friends and earn 50% of the trading fee</p> */}
                            </div>
                            {/* CATEGORY BAR */}
                            <div className="category-bar">
                                {categories.map((cat) => (
                                    <button
                                        key={cat._id}
                                        className={`category-btn ${categoryId === cat._id ? "active" : ""}`}
                                        onClick={() => {
                                            setCategoryId(cat._id);
                                            setPage(1);
                                        }}
                                    >
                                        {cat.name}
                                    </button>
                                ))}
                            </div>

                            {loading &&
                                <>
                                    <div className="blog-grid">
                                        {[0, 0, 0, 0, 0, 0, 0, 0, 0].map((_, index) => (
                                            <div className="blog-card" key={index}>
                                                <LoaderSkeleton />
                                            </div>
                                        ))}
                                    </div>
                                </>
                            }
                            {
                                (!loading && blogs.length > 0) &&
                                <div className="blog-grid">
                                    {blogs.map((b) => (
                                        <a className="blog-card" key={b?._id} href={b?.link} style={{ textDecoration: "none", color: "inherit" }}>

                                            <div className="blog-img-container">
                                                <img
                                                    src={b.image || b.loaderIcon}
                                                    alt={b.title}
                                                    className="blog-img"
                                                />
                                            </div>

                                            <div className="px-3">
                                                <h1 className="blog-title">{b.title}</h1>

                                                <p className="blog-desc">
                                                    {b.description.replace(/<[^>]+>/g, "").slice(0, 140)}...
                                                </p>

                                                <p className="blog-date">{b?.dateTime?.slice(0, 10)}</p>
                                            </div>
                                        </a>
                                    ))}
                                </div>
                            }

                            {!loading && blogs.length === 0 && (
                                <p className="no-blog-text">No Blogs Found</p>
                            )}
                            <div className="pagination-wrap">
                                <Pagination
                                    count={totalPages}
                                    page={page}
                                    onChange={(e, v) => setPage(v)}
                                // variant="outlined"
                                // size="large"
                                />
                            </div>
                        </div>
                    </ThemeProvider>
                </div>

            </div>
            <Footer />
        </div>
    );
};

export default Blogs;
